import React, { Component, Fragment } from "react";
import { Button, Modal } from "react-bootstrap";
import { Redirect } from "react-router-dom";

import { post, get } from "../../../utils/DeApi";
import { FieldGroup } from "../../../utils/BootstrapUtils";
import Loader from "../../Loader/Loader";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";

/**
 * Handles creation of a character using a modal.
 */
class CharacterCreate extends Component {
  constructor(props) {
    super(props);
    this.subscribedPromises = [];
    this.state = {
      show: false,
      title: "",
      description: "",
      characterType: "5bb22aca5c218",
      created: false
    };

    this.handleShowModal = this._handleShowModal.bind(this);
    this.handleCloseModal = this._handleCloseModal.bind(this);
    this.handleSubmit = this._handleSubmit.bind(this);
    this.handleSubmitAndNav = this._handleSubmitAndNav.bind(this);
    this.handleInputChange = this._handleInputChange.bind(this);
  }

  _handleCloseModal() {
    this.setState({ show: false });
  }

  _handleShowModal() {
    this.setState({ show: true });
  }

  _handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }

  _handleSubmit(event, callback) {
    event.preventDefault();
    this.setState({ validate: true });
    const project = this.props.project.id;
    const { title, description, characterType } = this.state;

    if (title && project && characterType) {
      this.setState({ isLoading: true });
      const createPromise = post("/characters", {
        project: project,
        title: title,
        description: description,
        characterType: characterType
      });
      createPromise.promise
        .then((response) => {
          if (callback) {
            callback(response.data);
          } else {
            this.setState({
              show: false,
              isLoading: false,
              error: "",
              title: "",
              description: "",
              characterType: "",
              validate: false
            });
            this.props.onCharacterCreated(response.data);
          }
        })
        .catch((error) => {
          !error.isCanceled &&
            this.setState({
              error: error,
              isLoading: false
            });
        });
      this.subscribedPromises.push(createPromise);
    }
  }

  _handleSubmitAndNav(event) {
    let redirectToPillar = function(pillar) {
      this.setState({
        error: "",
        title: "",
        description: "",
        created: pillar
      });
    };
    this.handleSubmit(event, redirectToPillar.bind(this));
  }

  fetchCharacterTypes() {
    let characterTypesPromise = get("/character-types");
    characterTypesPromise.promise
      .then((response) => {
        this.setState({
          characterTypes: response.data
        });
      })
      .catch((error) => {
        !error.isCanceled &&
          this.setState({
            error: error
          });
      });
    this.subscribedPromises.push(characterTypesPromise);
  }

  componentDidMount() {
    this.fetchCharacterTypes();
  }

  componentWillUnmount() {
    this.subscribedPromises.forEach(function(promise) {
      promise.cancel();
    });
  }

  render() {
    const {
      show,
      created,
      characterTypes,
      characterType,
      isLoading,
      title,
      description,
      error,
      validate
    } = this.state;
    const { project } = this.props;

    if (created) {
      return (
        <Redirect
          to={"/projects/" + project.id + "/characters/" + created.id}
          push
        />
      );
    }

    const form =
      characterTypes && !isLoading ? (
        <form onSubmit={this.handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title className="mt-0">
              Start with a title, type, and summary
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FieldGroup
              id="characterTitle"
              name="title"
              label="Character+ Name"
              type="text"
              onChange={this.handleInputChange}
              value={title}
              placeholder="Enter character+ name"
              autoFocus
              required
              maxLength={81}
              validationState={
                title.length > 80 || (validate && !title) ? "error" : null
              }
            />
            <FieldGroup
              id="characterType"
              name="characterType"
              label="Character+ Type"
              type="select"
              onChange={this.handleInputChange}
              componentClass="select"
              placeholder="Select character+ type"
              value={characterType}
              required
              validationState={validate && !characterType ? "error" : null}
            >
              <option value="" defaultValue hidden>
                Select character+ type
              </option>
              {characterTypes
                .sort((a, b) => {
                  if (a.id < b.id) return -1;
                  if (a.id > b.id) return 1;
                  return 0;
                })
                .map((characterType) => {
                  return (
                    <option value={characterType.id} key={characterType.id}>
                      {characterType.name}
                    </option>
                  );
                })}
            </FieldGroup>
            <FieldGroup
              id="characterDescription"
              name="description"
              label="Character+ Summary"
              componentClass="textarea"
              rows="8"
              onChange={this.handleInputChange}
              value={description}
              placeholder="Enter character+ summary (optional)"
              maxLength={5100}
              validationState={description.length > 5000 ? "error" : null}
            />
            {error && <ErrorHandler error={error} />}
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleCloseModal} bsStyle="link">
              Cancel
            </Button>
            <Button type="submit" bsStyle="default">
              Save
            </Button>
            <Button onClick={this.handleSubmitAndNav} bsStyle="primary">
              Save and Write
            </Button>
          </Modal.Footer>
        </form>
      ) : (
        <Loader />
      );

    return (
      <Fragment>
        <Button
          className={this.props.className}
          bsStyle="success"
          onClick={this.handleShowModal}
          block
        >
          {this.props.label || "Create Character+ "}
        </Button>
        <Modal show={show} onHide={this.handleCloseModal} backdrop="static">
          {form}
        </Modal>
      </Fragment>
    );
  }
}

export default CharacterCreate;
